var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.CModal,
    {
      attrs: {
        value: _setup.isOpen,
        title: "Add a custom map style",
        size: "lg",
      },
      on: { closed: _setup.handleCancel },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c(_setup.CButton, {
                    attrs: { text: "Cancel", variant: "secondary" },
                    on: { click: _setup.handleCancel },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: {
                      text: "Save",
                      disabled: !_setup.inputValue,
                      variant: "primary",
                    },
                    on: { click: _setup.handleSave },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        [
          _c("p", [
            _vm._v(
              "\n            Paste your public Style URL below to add it to your options.\n            "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://docs.mapbox.com/help/glossary/style-url/",
                  target: "_blank",
                  rel: "noopener noreferrer",
                },
              },
              [_vm._v("More info")]
            ),
            _vm._v(".\n        "),
          ]),
          _vm._v(" "),
          _c(_setup.CInput, {
            attrs: {
              label: "Custom Mapbox Style",
              placeholder: "mapbox://styles/username/style_id",
            },
            model: {
              value: _setup.inputValue,
              callback: function ($$v) {
                _setup.inputValue = $$v
              },
              expression: "inputValue",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }